var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iqp-context-menu",on:{"mousedown":_vm.handleBodyClick}},[_c('IqpContextSubmenu',{style:(`left:${_vm.left}px; top:${_vm.top}px; display:block;`),attrs:{"items":_vm.items},on:{"clickItem":_vm.handleItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }